import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ExplorerSJMapState } from '../../reducers/explorer/explorer-sjmap.reducer';
import { IRasterLayer } from '../../../interfaces/sjmap2/raster/IRaster';
import { IVectorLayer } from '../../../interfaces/sjmap2/vector/IVector';
import { TRasterLayerActiveSource, TRasterLayerUUID } from '../../../types/explorer/sjmap2/TRaster';
import { TVectorLayerActiveSource, TVectorLayerUUID } from '../../../types/explorer/sjmap2/TVector';

export const selectExplorerSJMap = createFeatureSelector<ExplorerSJMapState>('explorerSJMap');

export const _selectExplorerSJMap = createSelector(
    selectExplorerSJMap,
    (state) => state?.sjmap
);

export const selectExplorerSJMapProjectUUID = createSelector(
    selectExplorerSJMap,
    (state) => state?.projectUUID ?? null
);

export const selectExplorerSJMapLoading = createSelector(
    selectExplorerSJMap,
    (state) => state?.loading
);
export const selectExplorerSJMapError = createSelector(selectExplorerSJMap, (state) => state.error);

export const selectExplorerSJMapIsToUpdate = createSelector(selectExplorerSJMap, (state) => state.isToUpdate);

export const selectExplorerSJMapRasterLayerByUUID = (layerUUID: TRasterLayerUUID) => createSelector(
    selectExplorerSJMap,
    (state) => state?.sjmap.layers.find((layer) => layer.uuid === layerUUID) as IRasterLayer
);

export const selectExplorerSJMapRasterActiveSourceByUUID = (layerUUID: TRasterLayerUUID) => createSelector(
    selectExplorerSJMapRasterLayerByUUID(layerUUID),
    (layer) => layer?.activeSource as TRasterLayerActiveSource
);

export const selectExplorerSJMapVectorLayerByUUID = (layerUUID: TVectorLayerUUID) => createSelector(
    selectExplorerSJMap,
    (state) => state?.sjmap.layers.find((layer) => layer.uuid === layerUUID) as IVectorLayer
);

export const selectExplorerSJMapVectorActiveSourceByUUID = (layerUUID: TVectorLayerUUID) => createSelector(
    selectExplorerSJMapVectorLayerByUUID(layerUUID),
    (layer) => layer?.activeSource as TVectorLayerActiveSource
);

export const selectSourcesBylayerUUID = (layerUUID: IRasterLayer["uuid"]) => createSelector(
    selectExplorerSJMapRasterLayerByUUID(layerUUID),
    (layer) => layer?.sources as IRasterLayer["sources"]
);

export const selectActiveVectorLayerUUIDs = createSelector(
  _selectExplorerSJMap,
  (sjmap) => sjmap?.layers.filter(l => l.type === 'vector' && l.isVisible).map(l => l.uuid) as string[]
);

export const selectColormapLayerByUUID = (layerUUID: TRasterLayerUUID) => createSelector(
  selectExplorerSJMapRasterLayerByUUID(layerUUID),
  (layer) => layer?.activeSource?.colormap
);
export const selectLoadingDownloadRasterLayerSources = (layerUUID: string) => createSelector(
  selectExplorerSJMap,
  (state) => state?.downloadRasterLayerSources?.loadingLayerUUID === layerUUID
);